import { z } from "zod";

export enum ChatRole {
  USER = "user",
  AGENT = "agent",
}

export const chatSessionBaseSchema = z.object({
  id: z.number(),
  agent_id: z.string(),
  application_id: z.string().nullable(),
  initiator_type: z.string(),
  initiator_id: z.number(),
  finished_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

const messageContentBlockSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("text"),
    text: z.string(),
  }),
  z.object({
    type: z.literal("file"),
    file_id: z.number(),
    file_name: z.string(),
  }),
]);

const messageContentSchema = z.object({
  version: z.literal("1.0.0"),
  content: z.array(messageContentBlockSchema),
});

export const chatSessionMessageSchema = z.object({
  id: z.number(),
  ai_agent_session_id: z.number(),
  message: z.string().optional(),
  content: messageContentSchema.optional(),
  sender_type: z.nativeEnum(ChatRole),
  created_at: z.string(),
  updated_at: z.string(),
});

export const chatSessionSchema = chatSessionBaseSchema.extend({
  messages: z.array(chatSessionMessageSchema),
});

export type ChatSessionBase = z.infer<typeof chatSessionBaseSchema>;
export type ChatSession = z.infer<typeof chatSessionSchema>;
export type ApiChatMessage = z.infer<typeof chatSessionMessageSchema>;
export type MessageContentBlock = z.infer<typeof messageContentBlockSchema>;
export type MessageContent = z.infer<typeof messageContentSchema>;

export type CreateChatSessionPayload = {
  agent_id: string;
  application_id?: string;
};

export type PromptChatSessionPayload = {
  prompt?: string;
  content?: MessageContent;
};

export type IndexChatSessionsParams = {
  application_id?: string;
  finished?: 0 | 1;
} & Record<string, unknown>;

export type ChatMessage = {
  message?: string;
  content?: MessageContent;
  sender_type: ChatRole;
} & Partial<ApiChatMessage>;
